import { useHasPermission } from "../../auth/useClaims";

// A single permission gates the whole screen (view + manage together) -
// deliberately no separate ".View" permission, per explicit project
// decision (see feedback_no_separate_view_permission_for_masters):
// splitting View/Manage on a simple admin master is unnecessary friction
// for anyone who already holds broad create/manage grants elsewhere.
export const useCanManageChecklistItems = () => useHasPermission("Technical.ManageChecklistItems");
